import { render, staticRenderFns } from "./Flashmessages.vue?vue&type=template&id=78020547&"
import script from "./Flashmessages.vue?vue&type=script&lang=js&"
export * from "./Flashmessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports